import { illegalArity } from "@thi.ng/errors";
import { ensureTransducer } from "./internal/ensure";
import { reduce } from "./reduce";
import { map } from "./xform/map";
export function transduce(...args) {
    let acc, xs;
    switch (args.length) {
        case 4:
            xs = args[3];
            acc = args[2];
            break;
        case 3:
            xs = args[2];
            break;
        case 2:
            return map((x) => transduce(args[0], args[1], x));
        default:
            illegalArity(args.length);
    }
    return reduce(ensureTransducer(args[0])(args[1]), acc, xs);
}
